var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoninBookLightDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1203",
    "data-name": "Group 1203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255,
    height: 49.979,
    viewBox: "0 0 255 49.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1640",
    "data-name": "Rectangle 1640",
    width: 255,
    height: 49.979,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1619",
    "data-name": "Rectangle 1619",
    width: 9.508,
    height: 15.8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1620",
    "data-name": "Rectangle 1620",
    width: 0.031,
    height: 0.018,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1621",
    "data-name": "Rectangle 1621",
    width: 2.297,
    height: 2.233,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1622",
    "data-name": "Rectangle 1622",
    width: 2.084,
    height: 2.233,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1623",
    "data-name": "Rectangle 1623",
    width: 2.415,
    height: 2.624,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1624",
    "data-name": "Rectangle 1624",
    width: 2.021,
    height: 2.067,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 2.098,
    height: 2.034,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1626",
    "data-name": "Rectangle 1626",
    width: 1.772,
    height: 1.716,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1627",
    "data-name": "Rectangle 1627",
    width: 2.032,
    height: 2.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 1.916,
    height: 1.996,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1629",
    "data-name": "Rectangle 1629",
    width: 2.398,
    height: 2.456,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1630",
    "data-name": "Rectangle 1630",
    width: 2.122,
    height: 2.29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1631",
    "data-name": "Rectangle 1631",
    width: 9.501,
    height: 35.023,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1632",
    "data-name": "Rectangle 1632",
    width: 0.005,
    height: 0.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1633",
    "data-name": "Rectangle 1633",
    width: 31.121,
    height: 47.153,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1634",
    "data-name": "Rectangle 1634",
    width: 0.004,
    height: 0.044,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1635",
    "data-name": "Rectangle 1635",
    width: 0.002,
    height: 0.004,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1636",
    "data-name": "Rectangle 1636",
    width: 0.008,
    height: 0.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1637",
    "data-name": "Rectangle 1637",
    width: 14.49,
    height: 8.916,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1638",
    "data-name": "Rectangle 1638",
    width: 10.965,
    height: 22.094,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M170.229,49.674c-13.407,2.53-24.946-11.105-25.8-24.791C142.984,7.747,158.5-5.494,173.84,2.28a20.555,20.555,0,0,1,4.183,2.934,26.643,26.643,0,0,1,9.163,10.707c4.509,9.305,1.849,21.04-5.776,26.731a18.839,18.839,0,0,1-11.181,7.023",
    transform: "translate(-104.257 0)",
    fill: "#4d80ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M20.415,48.881c0,4.767-3.115,8.518-8.706,8.518H5.967V64.53a1.624,1.624,0,0,1-1.8,1.8H1.839A1.651,1.651,0,0,1,0,64.53V41.864a1.651,1.651,0,0,1,1.839-1.8h9.87c5.628,0,8.706,4.091,8.706,8.818m-6,.038a3.526,3.526,0,0,0-3.49-3.827H5.967v7.58H10.92a3.5,3.5,0,0,0,3.49-3.753",
    transform: "translate(0 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M87.561,64.53V41.864a1.652,1.652,0,0,1,1.839-1.8h2.327a1.624,1.624,0,0,1,1.8,1.8v9.495h9.832V41.864a1.623,1.623,0,0,1,1.8-1.8h2.326a1.624,1.624,0,0,1,1.8,1.8V64.53a1.624,1.624,0,0,1-1.8,1.8h-2.326a1.623,1.623,0,0,1-1.8-1.8V56.2H93.528V64.53a1.624,1.624,0,0,1-1.8,1.8H89.4a1.652,1.652,0,0,1-1.839-1.8",
    transform: "translate(-63.249 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M285.107,64.53V41.864a1.652,1.652,0,0,1,1.839-1.8H288.3a2.478,2.478,0,0,1,2.214,1.126l10.545,14.485V41.864a1.651,1.651,0,0,1,1.839-1.8h2.326a1.624,1.624,0,0,1,1.8,1.8V64.53a1.624,1.624,0,0,1-1.8,1.8h-1.35a2.419,2.419,0,0,1-2.177-1.126L291.074,50.57V64.53a1.624,1.624,0,0,1-1.8,1.8h-2.327a1.652,1.652,0,0,1-1.839-1.8",
    transform: "translate(-205.943 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M385.236,64.53V41.864a1.652,1.652,0,0,1,1.839-1.8H389.4a1.624,1.624,0,0,1,1.8,1.8V64.53a1.624,1.624,0,0,1-1.8,1.8h-2.327a1.652,1.652,0,0,1-1.839-1.8",
    transform: "translate(-278.27 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M427.8,64.53V41.864a1.652,1.652,0,0,1,1.839-1.8h1.351a2.477,2.477,0,0,1,2.214,1.126l10.545,14.485V41.864a1.651,1.651,0,0,1,1.839-1.8h2.326a1.624,1.624,0,0,1,1.8,1.8V64.53a1.624,1.624,0,0,1-1.8,1.8h-1.35a2.419,2.419,0,0,1-2.177-1.126L433.766,50.57V64.53a1.624,1.624,0,0,1-1.8,1.8h-2.327a1.652,1.652,0,0,1-1.839-1.8",
    transform: "translate(-309.015 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M548.825,58.9c0,4.5-3.715,7.431-9.343,7.431h-9.72a1.651,1.651,0,0,1-1.839-1.8V41.864a1.651,1.651,0,0,1,1.839-1.8h8.631c5.33,0,9.233,2.7,9.233,7.2a5.6,5.6,0,0,1-4.2,5.442,6.189,6.189,0,0,1,5.4,6.191M533.89,44.792v6.379h3.152c3.378,0,4.766-1.613,4.766-3.3,0-1.952-1.651-3.077-3.865-3.077Zm9.081,13.659c0-1.727-1.463-3.416-4.953-3.416H533.89v6.492h5.366c2.364,0,3.715-1.351,3.715-3.077",
    transform: "translate(-381.338 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M612.649,52.123A13.927,13.927,0,1,1,626.572,65.67a13.466,13.466,0,0,1-13.923-13.547m21.877,0c0-4.653-3.3-8.368-7.954-8.368s-7.919,3.715-7.919,8.368,3.266,8.368,7.919,8.368,7.954-3.715,7.954-8.368",
    transform: "translate(-442.539 -27.865)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M722.5,52.123A13.927,13.927,0,1,1,736.426,65.67,13.466,13.466,0,0,1,722.5,52.123m21.877,0c0-4.653-3.3-8.368-7.954-8.368s-7.919,3.715-7.919,8.368,3.266,8.368,7.919,8.368,7.954-3.715,7.954-8.368",
    transform: "translate(-521.891 -27.865)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M847.9,61.378,844,54.247V64.53a1.623,1.623,0,0,1-1.8,1.8H839.87a1.652,1.652,0,0,1-1.839-1.8V41.864a1.652,1.652,0,0,1,1.839-1.8H842.2a1.623,1.623,0,0,1,1.8,1.8V52.071L850.94,41.3a2.241,2.241,0,0,1,2.14-1.238h3c1.35,0,1.651.751.863,1.989l-7.317,11,3.528,5.967c1.2,2.176,2.25,3.039,3.564,2.964a6.179,6.179,0,0,0,1.164-.263c.976-.3,1.426.112,1.876,1.088l.375.826a1.7,1.7,0,0,1-1.014,2.476,8.834,8.834,0,0,1-3.378.638c-3.414,0-6.191-2.026-7.842-5.366",
    transform: "translate(-605.341 -28.939)",
    fill: "#ccdbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M165.181,48.433a.94.94,0,0,1-.159-.459c-.015-.055-.03-.11-.046-.164-.108-.333-.23-.662-.341-.994s-.228-.693-.336-1.042c-.216-.7-.4-1.4-.555-2.1-.188-.846-.352-1.7-.5-2.551s-.286-1.7-.444-2.55c-.136-.731-.285-1.459-.445-2.185-.191-.827-.413-1.645-.654-2.458s-.488-1.6-.729-2.4c-.5-1.647-1.009-3.288-1.462-4.947-.111-.408-.231-.814-.341-1.223s-.222-.828-.331-1.243-.208-.826-.308-1.24-.208-.853-.3-1.281l-.029-.131-.032-.144c-.03-.135-.059-.27-.076-.343-.225-1-.5-1.991-.8-2.953l-.028-.091c-.1-.315-.2-.63-.293-.938a20.493,20.493,0,0,1-.617-2.364,4.228,4.228,0,0,1-.079-.674,4.718,4.718,0,0,1,.021-.542,1.493,1.493,0,0,1,.154-.58,1.643,1.643,0,0,1,.344-.414,2.814,2.814,0,0,1,.784-.521,3.811,3.811,0,0,1,.882-.235c.326-.055.658-.067.988-.092a9.486,9.486,0,0,0,.979-.125c.418-.079.832-.176,1.245-.277s.8-.195,1.206-.293.822-.2,1.231-.308.8-.225,1.2-.348c.809-.25,1.578-.606,2.367-.91.407-.157.821-.291,1.241-.413s.819-.235,1.231-.345.83-.222,1.25-.31a6.34,6.34,0,0,1,.694-.092c.226-.022.451-.049.675-.087a7.291,7.291,0,0,0,1.156-.338c.375-.142.743-.3,1.121-.438s.764-.247,1.153-.343a4.895,4.895,0,0,1,.673-.115c.212-.022.423-.041.634-.072l.092-.015a15.692,15.692,0,0,0,2.27-.7c.195-.069.39-.134.584-.2s.408-.145.618-.2c.194-.049.391-.088.589-.122s.383-.051.574-.084c.264-.05.522-.121.781-.192.126-.034.253-.069.38-.1a8.654,8.654,0,0,1,1.145-.217,1.9,1.9,0,0,1,.574.006,1.475,1.475,0,0,1,.513.2,1.681,1.681,0,0,1,.476.525,5.969,5.969,0,0,1,.381.687,16.512,16.512,0,0,1,1.078,3.487l.029.129c.277,1.233.51,2.476.78,3.712.169.75.358,1.5.555,2.239s.392,1.461.614,2.184c.239.761.485,1.519.711,2.248l0,0c.047.152.095.3.117.378.032.1.063.2.07.227.108.348.215.7.3.968l.01.032.082.265c.007.022.014.044.021.067.022.062.039.127.043.14l.018.057.011.034,0,.015.007.024c.015.047.029.094.033.107.265.851.513,1.707.769,2.561q.374,1.25.727,2.507c.24.852.47,1.708.7,2.564s.447,1.7.654,2.558c.219.906.425,1.815.624,2.713l.012.055v0l.029.131c.222.994.466,1.983.7,2.974.023.1.064.371-.1.377a.236.236,0,0,1-.169-.1.655.655,0,0,1-.131-.264c-.2-.835-.382-1.674-.58-2.509s-.417-1.665-.619-2.5c-.206-.852-.414-1.7-.636-2.553s-.478-1.717-.724-2.572c-.218-.759-.425-1.52-.643-2.28-.225-.787-.462-1.571-.7-2.353l-.007-.024v0l-.052-.166-.077-.246c-.1-.325-.206-.648-.3-.951l-.014-.043,0-.011-.027-.084c-.009-.026-.017-.051-.024-.077-.032-.1-.065-.207-.1-.31-.022-.071-.045-.141-.061-.194l-.016-.052,0-.011-.077-.246-.058-.186-.075-.24c-.027-.089-.055-.178-.07-.226-.26-.833-.509-1.669-.756-2.506s-.488-1.659-.715-2.494c-.232-.853-.455-1.707-.639-2.572-.179-.841-.335-1.687-.506-2.53q-.072-.354-.149-.707c-.141-.618-.288-1.234-.474-1.841l-.044-.142c-.1-.3-.2-.594-.316-.887q-.12-.292-.257-.575c-.043-.082-.087-.162-.134-.242q-.042-.064-.085-.127t-.085-.1l-.046-.044c-.025-.019-.051-.037-.077-.055s-.051-.026-.078-.038a1.641,1.641,0,0,0-.29-.068,5.433,5.433,0,0,0-.95.006c-.176.013-.354.025-.529.049s-.355.058-.51.086c-.2.038-.408.079-.611.129s-.387.114-.58.174a11.173,11.173,0,0,1-1.211.284c-.8.153-1.587.37-2.372.589a8.736,8.736,0,0,0-1.047.344c-.176.074-.349.155-.526.229s-.347.132-.524.189c-.336.109-.676.207-1.018.294s-.7.157-1.055.222c-.394.074-.786.16-1.171.272-.415.121-.817.276-1.228.408-.193.061-.392.1-.589.145l-.593.135c-.413.094-.824.195-1.234.307-.425.116-.847.242-1.265.381-.4.133-.794.273-1.193.406-.8.266-1.6.518-2.413.733s-1.636.4-2.461.567c-.42.083-.843.149-1.267.21-.4.058-.8.1-1.2.146-.26.031-.519.066-.778.1s-.5.056-.755.1a2.693,2.693,0,0,0-.739.25,2.119,2.119,0,0,0-.4.3,1.62,1.62,0,0,0-.209.264,1.289,1.289,0,0,0-.069.154c-.009.033-.018.066-.025.1-.008.052-.014.1-.018.157,0,.085,0,.17,0,.255.012.209.035.418.061.627s.068.415.111.621c.181.795.43,1.575.663,2.355.243.816.475,1.636.7,2.457s.47,1.657.685,2.491c.114.441.217.884.314,1.329.085.391.16.784.242,1.176.027.13.055.259.077.36l.007.031h0c.187.818.416,1.627.645,2.434s.488,1.635.737,2.451c.5,1.63.987,3.263,1.393,4.918.209.849.391,1.7.575,2.559s.373,1.7.54,2.558c.173.889.349,1.777.532,2.6l.005.023c.2.854.407,1.7.662,2.543q.192.6.4,1.19c.134.392.265.788.416,1.174l.012.028a.96.96,0,0,1,.132.4c.009.107,0,.292-.122.337l-.012,0c-.122.033-.237-.1-.3-.188",
    transform: "translate(-112.878 -3.548)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M214.657,126.875a15.87,15.87,0,0,1-1.7.284c-.423.1-.821.285-1.254.352-.495.079-.983.186-1.471.3a4.912,4.912,0,0,0-1.477.5,14.122,14.122,0,0,1-1.466.518,27.751,27.751,0,0,1-3.369.755c-.374.073-.714.247-1.078.357-.7.2-1.42.311-2.125.488-1.051.283-2.1.577-3.14.891-1.05.285-2.133.436-3.162.8-1.057.354-2.144.6-3.21.931a5.106,5.106,0,0,1-2.172.358c-1.125-.194-1.573-1.449-1.817-2.425a14.559,14.559,0,0,0-.438-1.51,1.553,1.553,0,0,1-.139-.688c.169-.3.436.476.477.6.208.64.415,1.281.666,1.906a1.743,1.743,0,0,0,.737.978,2.693,2.693,0,0,0,1.6.235,14.883,14.883,0,0,0,4.1-1.18c1.041-.315,2.127-.455,3.163-.793,1.74-.516,3.489-1.007,5.248-1.454a7.1,7.1,0,0,0,1.613-.493c.831-.3,1.671-.581,2.521-.822.852-.292,1.761-.333,2.62-.586.634-.23,1.23-.556,1.869-.775a7.747,7.747,0,0,1,1.9-.258c.378-.092.762-.164,1.147-.223a8,8,0,0,0,2.231-.79,5.059,5.059,0,0,0,.859-.742.822.822,0,0,0,.2-.35,13.142,13.142,0,0,0-.755-3.386c-.076.039-.134-.088-.146-.143-.08-.332-.165-.662-.264-.989-.046-.144-.092-.288-.14-.432a.619.619,0,0,1-.034-.52c.159-.151.333.121.384.257a38.01,38.01,0,0,1,1.3,5.142c.1.5.327,1.075-.074,1.5a3.625,3.625,0,0,1-1.616.945,12.74,12.74,0,0,1-1.6.464",
    transform: "translate(-134.813 -85.615)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M248.332,47.807a.166.166,0,0,0-.117-.051.2.2,0,0,1,.117.051m-8.865-37.437a78.793,78.793,0,0,1,2.552,10.476c.881,3.617,2.022,7.166,3,10.757.99,3.567,1.889,7.2,2.674,10.8.089.749,1.663,6.176.677,5.958-.241-.083-.264-.39-.239-.6-.288-2.7-.94-5.427-1.486-8.069-1.192-5.519-2.96-10.887-4.42-16.337-.514-1.788-1.025-3.58-1.367-5.411-.346-1.758-.545-3.467-1.018-5.147a7.363,7.363,0,0,0-1.178-2.845,1.375,1.375,0,0,1-.175-.441c.174-.061.348-.123.521-.185a5.271,5.271,0,0,1,.461,1.05",
    transform: "translate(-172.267 -6.731)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M249.515,27.707a6.244,6.244,0,0,1,.17.632c.054.233.1.466.146.7.069.382.158.76.254,1.136.045.179.1.357.156.533.065.195.144.383.217.576a4.281,4.281,0,0,1,.155.544,1.434,1.434,0,0,1,.036.47,1,1,0,0,1-.355.6,2.089,2.089,0,0,1-.277.215c-.108.074-.218.145-.329.213l-.168.1c.035,0,.069,0,.1.005a1.225,1.225,0,0,1,.7.315,2.11,2.11,0,0,1,.4.49c.121.191.224.395.326.6.087.17.174.341.255.515a8.205,8.205,0,0,1,.472,1.236c.11.385.193.778.269,1.171s.135.8.221,1.194a6.1,6.1,0,0,0,.3.946,4.563,4.563,0,0,1,.177.483,1.112,1.112,0,0,1,.034.252.591.591,0,0,1-.085.3,1.582,1.582,0,0,1-.143.225,1.538,1.538,0,0,1-.273.263,3.073,3.073,0,0,1-.409.283c-.1.055-.2.1-.293.156l-.032.027a1.784,1.784,0,0,1-.34.217,3.34,3.34,0,0,1-.555.207c-.115.033-.231.061-.345.1-.08.024-.159.049-.24.07l-.061.016a1.194,1.194,0,0,1-.393.039.4.4,0,0,1-.308-.138c-.131-.205.186-.4.333-.469.083-.038.167-.073.251-.106.156-.065.305-.145.46-.212a3.871,3.871,0,0,1,.456-.164c.037-.011.074-.02.111-.029l.022-.005.059-.034c.078-.052.156-.106.23-.162.031-.027.063-.053.093-.081l.018-.02,0-.009.006-.017c0-.052,0-.1,0-.156a1.592,1.592,0,0,0-.007-.182,4.3,4.3,0,0,0-.21-.754,9.862,9.862,0,0,1-.249-1.031c-.083-.406-.15-.815-.207-1.226a10.939,10.939,0,0,0-.189-1.182c-.053-.207-.1-.414-.165-.618a5.758,5.758,0,0,0-.219-.585,3.781,3.781,0,0,0-.555-.892,2.033,2.033,0,0,0-.3-.276c-.034-.022-.069-.042-.106-.061l-.072-.025-.036-.007h-.069c-.147.011-.294.029-.44.048-.4.059-.8.124-1.2.211-.084.019-.168.041-.254.056a.563.563,0,0,1-.451-.064c-.125-.113,0-.269.107-.339a1.83,1.83,0,0,1,.381-.166c.093-.036.187-.071.28-.108l.088-.035c.172-.07.343-.141.518-.2.218-.08.437-.155.654-.237.07-.031.139-.062.208-.1s.13-.069.194-.107l.036-.025.027-.024c.031-.034.06-.069.089-.1l0-.006c.009-.028.017-.056.024-.084a.378.378,0,0,0,0-.05c-.026-.179-.077-.355-.115-.531-.027-.129-.056-.257-.08-.387-.03-.159-.043-.32-.058-.48a9.457,9.457,0,0,0-.171-.97c-.085-.372-.177-.74-.291-1.1-.124-.4-.243-.8-.345-1.2-.05-.2-.1-.393-.155-.587a4.967,4.967,0,0,0-.189-.509,3.615,3.615,0,0,0-.5-.817,2.2,2.2,0,0,0-.274-.25,2.026,2.026,0,0,0-.207-.114c-.049-.019-.1-.036-.149-.051l-.066-.015h-.011l-.109.011c-.111.017-.221.038-.331.061-.232.056-.46.124-.693.177-.151.034-.3.067-.454.094a1.179,1.179,0,0,1-.533.017.33.33,0,0,1-.071-.03.159.159,0,0,1-.062-.233.671.671,0,0,1,.347-.247c.141-.057.282-.1.428-.148a5.93,5.93,0,0,1,.639-.149c.172-.056.344-.112.513-.178.073-.031.145-.064.216-.1l.077-.044.077-.053.047-.042.034-.04c.017-.024.033-.049.047-.075,0-.008.005-.016.008-.024a.929.929,0,0,0,.01-.21,6.724,6.724,0,0,0-.145-.715c-.043-.178-.071-.358-.111-.537s-.077-.329-.118-.493c-.046-.184-.092-.368-.146-.549s-.117-.357-.166-.538a3.455,3.455,0,0,1-.083-.517c-.024-.211-.042-.423-.062-.634-.039-.375-.084-.749-.156-1.119-.039-.2-.086-.391-.13-.586a3.73,3.73,0,0,0-.191-.609,2.475,2.475,0,0,0-.3-.483,2.043,2.043,0,0,0-.269-.248,2.306,2.306,0,0,0-.263-.15l-.1-.036q-.068-.017-.137-.028c-.059-.007-.117-.014-.177-.017l-.147,0c-.084.006-.167.016-.25.027s-.18.031-.269.05c-.172.041-.343.083-.515.122a2.708,2.708,0,0,1-.339.062.929.929,0,0,1-.222,0q-.043-.155-.089-.308a1,1,0,0,1,.123-.083,1.553,1.553,0,0,1,.357-.144,5.136,5.136,0,0,1,.6-.136,5.792,5.792,0,0,1,1.277-.093,1.888,1.888,0,0,1,1.217.5,2.873,2.873,0,0,1,.672,1.2A8.13,8.13,0,0,1,246.93,20c.038.285.094.567.156.848.029.13.057.261.082.392.029.151.039.305.051.415a6.4,6.4,0,0,0,.262,1.247c.064.2.15.4.214.6.051.16.1.323.134.486.028.118.044.238.069.356.009.044.019.088.029.132a.409.409,0,0,1-.034.322,1.124,1.124,0,0,1-.383.356q.065.017.129.039a2.075,2.075,0,0,1,.563.348,3.553,3.553,0,0,1,.444.406,2.518,2.518,0,0,1,.376.549,6.412,6.412,0,0,1,.262.6c.08.2.159.407.23.614",
    transform: "translate(-175.112 -12.103)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M269.473,106.129c1.322,1.425,1.4,3.542,1.879,5.341.212.95.562,1.874-.272,2.644a4.5,4.5,0,0,1-1.831,1.03,5.157,5.157,0,0,1-1.7.535.826.826,0,0,1-.155-.031l-.014-.086q-.012-.076-.025-.151l-.025-.151c0-.021-.007-.043-.011-.066a.885.885,0,0,1,.47-.248c.834-.218,1.907-.425,2.391-1.2a3.769,3.769,0,0,0-.091-1.69c-.209-.974-.258-1.975-.5-2.942a4.332,4.332,0,0,0-1-2.315,6.7,6.7,0,0,0-2.1.238,5.967,5.967,0,0,1-.838.184c-.045-.183-.09-.366-.135-.548a6.038,6.038,0,0,1,1.092-.315c.915-.117,2-.7,2.874-.226",
    transform: "translate(-191.786 -76.529)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M272.064,139.487a.18.18,0,0,1,.129.114.2.2,0,0,1-.079.188c-.016-.1-.032-.2-.05-.3",
    transform: "translate(-196.522 -100.757)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M208.8,85.413a5.064,5.064,0,0,1-2.177-1.023c-2.2-1.354-3.5-3.822-4.578-6.091a7.894,7.894,0,0,1-.819-4.066,6.107,6.107,0,0,1,.562-2.092c.7-1.147,2.292-1.845,3.484-2.392,5.225-2.027,7.4,2.983,7.509,7.367a15.07,15.07,0,0,1-.47,5.388,4.868,4.868,0,0,1-1.662,2.452,2.642,2.642,0,0,1-1.849.457m.815-.927a3.735,3.735,0,0,0,1.855-1.98,9.4,9.4,0,0,0,.8-4.965,18.975,18.975,0,0,0-.25-2.666,8.773,8.773,0,0,0-1.241-3.241,2.532,2.532,0,0,0-1.992-1.231c-2.315-.35-4.97.26-6.4,2.24a5.245,5.245,0,0,0-.205,4.821c.958,2.388,2.278,4.87,4.545,6.237a4.762,4.762,0,0,0,2.882.786",
    transform: "translate(-145.326 -50.047)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M200.914,79.577c-.26,0-.52,0-.779,0-.232,0-.463-.014-.694-.028l-.627-.039a8.638,8.638,0,0,1-1.044-.462c-.343-.182-.681-.38-1.008-.59s-.658-.44-.97-.683c-.154-.12-.3-.244-.451-.371s-.288-.27-.427-.41c-.263-.266-.507-.554-.749-.84a10.816,10.816,0,0,1-.676-.9,19.227,19.227,0,0,1-1.2-2.042,19.62,19.62,0,0,1-.9-2.064,16.754,16.754,0,0,1-.652-2.251,7.039,7.039,0,0,1-.1-2.292c.021-.194.049-.387.08-.58s.08-.38.129-.569a9.863,9.863,0,0,1,.855-2.113q.259-.487.564-.948c.2-.306.425-.6.655-.886a9.247,9.247,0,0,1,.8-.883,7.2,7.2,0,0,1,.847-.71c.308-.217.634-.409.96-.6a10.176,10.176,0,0,1,1.567-.761c.264-.1.535-.171.807-.241q.449-.116.9-.209c.07-.014.149.058.191.1a.759.759,0,0,1,.157.282c.039.122.084.381-.092.417-.138.029-.277.06-.38.084q-.462.112-.919.248c-.313.094-.619.2-.924.321a11.319,11.319,0,0,0-1.736.85c-.128.081-.255.163-.376.254s-.241.19-.357.291c-.254.221-.5.451-.707.674l-.13.147c-.146.171-.288.345-.426.523s-.288.36-.416.551c-.255.382-.489.774-.706,1.178-.147.29-.291.582-.411.885s-.233.632-.332.954c-.045.167-.086.333-.124.5s-.055.326-.08.488c-.033.272-.056.541-.071.814v.062c0,.065,0,.128,0,.188,0,.007,0,.013,0,.02v0c0,.17.014.339.027.508s.046.345.075.517c.074.389.157.775.257,1.159.094.325.2.644.3.96l.008.021,0,0,.019.051c.015.042.03.084.044.122l.006.016.006.016.016.044.013.036.009.025c.118.317.254.627.392.936.207.437.422.868.658,1.29q.17.285.342.568c.115.188.241.369.364.552.187.264.38.523.582.775.13.151.259.3.4.444.168.171.336.34.476.477.126.116.252.23.382.342s.25.2.377.3c.25.185.505.362.765.533s.523.32.783.467l.011.006.005,0c.2.106.392.21.6.3.226.1.456.188.651.259a6.806,6.806,0,0,0,1.088.275c.184.026.368.044.552.069.093.013.185.028.277.047a1.274,1.274,0,0,1,.153.046.282.282,0,0,1,.038.018.183.183,0,0,1,.107.034.54.54,0,0,1,.172.209.835.835,0,0,1,.074.206h-.068",
    transform: "translate(-137.667 -41.974)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M224.112,79.185c-.227.028-.455.051-.684.064s-.446.016-.669.018c-.246,0-.491-.009-.737-.011s-.519,0-.779.006h-.011c-.228,0-.455-.014-.683-.028q-.312-.018-.624-.039a.929.929,0,0,1-.116-.324c-.026-.446.2-.286.478-.193,1.125.282,2.515.75,3.6.13a11.09,11.09,0,0,0,2.2-1.919,10.647,10.647,0,0,0,2.121-6.547,17.294,17.294,0,0,0-.8-4.943,17.276,17.276,0,0,0-1.615-4.083,5.7,5.7,0,0,0-2.5-2.607,8.325,8.325,0,0,0-1.725-.275l-.343-.022c-.257-.04-.38-.394-.349-.624.011-.05.047-.126.111-.122a8.922,8.922,0,0,1,1.126.132c2.06.293,3.093,1.344,4.06,3.105a18.173,18.173,0,0,1,1.771,4.845,17.092,17.092,0,0,1,.33,8.8,7.158,7.158,0,0,1-2.866,3.892c-.347.237-.7.484-1.061.706l-.232.035",
    transform: "translate(-158.775 -41.654)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M224.865,135.444h0",
    transform: "translate(-162.428 -97.836)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M218.261,58.507a29.55,29.55,0,0,0-3.157.284c-.089.014-.254-.013-.2-.141.121-.233.432-.219.654-.269.1-.2.339-.288.527-.385a3.393,3.393,0,0,1,1.4-.256c.179.021.664-.075.618.219a2.43,2.43,0,0,1,.46-.021c.073.009.17.026.2.106.058.252-.312.412-.507.464",
    transform: "translate(-155.226 -41.707)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M223.261,131.9l-.307.037c-.2,0-.4-.008-.6-.009-.26,0-.52,0-.779,0-.232,0-.463-.014-.694-.028l-.553-.034h0c-.282-.343.547-.682.815-.569a14.908,14.908,0,0,0,3.274-.146,9.168,9.168,0,0,0,1.425-.525c.086-.038.266-.084.339,0,.129.264-.672.454-.844.584a6.722,6.722,0,0,1-1.372.526c-.232.062-.467.114-.7.155",
    transform: "translate(-159.108 -94.324)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M221.517,127.72a8.872,8.872,0,0,1-2.494-.024,6.509,6.509,0,0,1-1.2-.173c-.36-.16-.206-.517.071-.672a2.407,2.407,0,0,1,1.545-.121c.473.051.942.131,1.415.183a5.2,5.2,0,0,0,1.7.043,4.4,4.4,0,0,0,1.966-1.66c.23-.241.351-.691.728-.726.155,0,.119.182.047.265a5.747,5.747,0,0,1-3.773,2.884",
    transform: "translate(-157.189 -89.982)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M187.1,42.029a.767.767,0,0,1-.783-.411,4.217,4.217,0,0,1-.534-2.407,1.86,1.86,0,0,1,.733-1.734c3.311-1.433,6.447-3.595,10.122-3.952,3.28-.392,3.665-.879,3.618,2.827-.031.62.193,1.423-.419,1.828a.374.374,0,0,1-.419.052,8.076,8.076,0,0,0-2.321.283,36.153,36.153,0,0,0-5.783,1.807,18.331,18.331,0,0,1-3.288,1.113,1.687,1.687,0,0,1-.925.594m.906-1.257c1.555-1.13,3.53-1.486,5.353-1.982a57.258,57.258,0,0,1,6.051-1.276c-.188-.92-.5-1.809-.673-2.731-.1-.8-1.8-.293-2.322-.181a58.9,58.9,0,0,0-9.635,3.675,5.665,5.665,0,0,0,.322,1.787c.079.278.061.581.166.85.239-.023.487-.195.737-.142",
    transform: "translate(-134.191 -24.025)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M146.8,47.456c-.5-.121,0-.867.258-1.035a3.479,3.479,0,0,1,2.132-.9,20.582,20.582,0,0,0,2.039-.45c.331-.045,1.146-.546,1.373-.271.132.266-.066.576-.224.788-.46.594-1.319.5-1.968.748-.633.189-1.252.432-1.868.669-.553.16-1.155.673-1.743.448",
    transform: "translate(-105.886 -32.304)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M152.4,59a1.762,1.762,0,0,1-.8-.018c-.132-.046-.135-.2-.111-.317a1.721,1.721,0,0,1,.861-.941,11.73,11.73,0,0,1,3.417-1.184,11.569,11.569,0,0,1,1.182-.257c.375-.079.437.324.322.593-.326,1.013-1.474,1.162-2.361,1.414A24.476,24.476,0,0,1,152.4,59",
    transform: "translate(-109.414 -40.645)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M156.111,70.882a8.074,8.074,0,0,1-2.5.285c-.38-.455,1.142-1.147,1.466-1.339a12.9,12.9,0,0,1,2.417-1.042c.45-.073,2.416-.842,2.232.084-.366,1.268-2.493,1.66-3.614,2.011",
    transform: "translate(-110.915 -49.42)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M159.9,83.611c-.38.046-1.514.327-1.371-.353a1.265,1.265,0,0,1,.424-.669,5.807,5.807,0,0,1,2.726-1.03c.638-.091,1.278-.157,1.908-.3.373-.042,1.077-.367.854.331-.266.806-1.217.884-1.9,1.165-.878.29-1.738.644-2.64.854",
    transform: "translate(-114.5 -58.617)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M162.177,95.523a3.772,3.772,0,0,1-.723.072c-.134,0-.275,0-.411,0-.252.174-.535.065-.452-.262a1.067,1.067,0,0,1,.771-.793,12.6,12.6,0,0,1,4.964-1.372c.278-.066.343.26.249.458-.246.772-1.128.872-1.774,1.159-.865.273-1.735.548-2.622.742",
    transform: "translate(-115.99 -67.29)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M166.413,108.282c-.279,0-.757.109-.92-.169-.055-.423.416-.713.749-.87a13.948,13.948,0,0,1,3.441-.8c.336-.049,1.407-.668,1.19.094-.18.588-.824.72-1.348.847a14.448,14.448,0,0,1-3.111.9",
    transform: "translate(-119.539 -76.685)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M172.242,120.031c-.429.1-4.2.829-3.778-.053.559-.908,3.934-1.491,5.024-1.53.256-.005.5.106.754.086.19-.01.167.239.129.352a1.059,1.059,0,0,1-.769.657,5.362,5.362,0,0,1-1.36.49",
    transform: "translate(-121.664 -85.559)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M175.818,131.309a22.492,22.492,0,0,1-3.914.77c-.176,0-.438.074-.565-.073-.265-.912,2.434-1.715,3.12-1.94a11.984,11.984,0,0,1,2.706-.459c.3.025.28.353.209.568a1.86,1.86,0,0,1-1.554,1.135",
    transform: "translate(-123.751 -93.619)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M176.225,144.038a10.741,10.741,0,0,1-2.982.375c-.336-.413.356-1.219.786-1.3.464,0,.914-.217,1.385-.243a17.837,17.837,0,0,0,2.724-.594c.392-.074,1.617-.482,1.345.256-.508,1.1-2.2,1.273-3.258,1.507",
    transform: "translate(-125.075 -102.642)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M178.7,156.062c-.426.03-.855.038-1.281.075-.6.057-1.207.16-.777-.667.172-.294.5-.682.883-.6.567-.114,1.114-.317,1.669-.479a11.906,11.906,0,0,1,2.753-.655c.335-.04.758-.149,1.04.071.358,1.316-3.305,2.286-4.287,2.255",
    transform: "translate(-127.487 -111.004)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M183.171,33.14a18.173,18.173,0,0,0-1.771-4.845c-.967-1.761-2-2.812-4.06-3.105q-.291-.053-.584-.087a.869.869,0,0,0-.242-.024c-.1-.009-.2-.016-.3-.021a.08.08,0,0,0-.058.022,3.753,3.753,0,0,0-.928.124.131.131,0,0,0-.09-.021q-.454.093-.9.209c-.272.07-.543.145-.807.241a10.175,10.175,0,0,0-1.567.761c-.326.187-.652.379-.96.6a7.225,7.225,0,0,0-.847.709,9.286,9.286,0,0,0-.8.883c-.23.285-.453.58-.655.886s-.391.624-.564.948a9.876,9.876,0,0,0-.855,2.113c-.049.188-.1.377-.129.569s-.059.386-.08.579a7.031,7.031,0,0,0,.1,2.292,16.729,16.729,0,0,0,.652,2.251,19.647,19.647,0,0,0,.9,2.064,19.21,19.21,0,0,0,1.2,2.042,10.753,10.753,0,0,0,.676.9c.241.286.485.574.748.84.139.14.277.282.427.41s.3.252.451.371c.311.243.637.47.97.683s.665.408,1.008.59c.106.056.212.109.32.16a.3.3,0,0,0,.21.3,6.522,6.522,0,0,0,1.2.173,8.894,8.894,0,0,0,2.495.024,3.9,3.9,0,0,0,.7-.173c.1-.01.2-.021.3-.034l.232-.035c.363-.222.714-.469,1.061-.706.107-.078.212-.157.316-.24h0a.549.549,0,0,0,.077-.061,6.914,6.914,0,0,0,2.472-3.59,17.092,17.092,0,0,0-.33-8.8m-3.1-11.767c.047-3.706-.338-3.219-3.618-2.827-3.675.358-6.811,2.52-10.122,3.952a1.86,1.86,0,0,0-.733,1.734,4.219,4.219,0,0,0,.534,2.407.767.767,0,0,0,.783.41,1.683,1.683,0,0,0,.925-.593,18.354,18.354,0,0,0,3.288-1.113,36.182,36.182,0,0,1,5.783-1.807,8.112,8.112,0,0,1,2.321-.283.374.374,0,0,0,.419-.052c.612-.405.388-1.208.419-1.828m1.508-6.268c.474,1.68.673,3.389,1.018,5.147.342,1.831.853,3.623,1.367,5.411.485,1.809,1,3.609,1.523,5.408a.152.152,0,0,0,.023.2.274.274,0,0,0,.045.033c.757,2.618,1.514,5.235,2.172,7.878v0q.068.273.134.547.275,1.129.521,2.266c.387,1.874.827,3.791,1.153,5.711,0,.022.008.044.011.065.009.051.017.1.025.151s.017.1.025.151l.014.086c.1.634.189,1.267.257,1.9-.426.183-.844.386-1.281.544-.859.253-1.767.295-2.62.586-.85.24-1.69.519-2.52.822a7.1,7.1,0,0,1-1.613.493c-1.759.446-3.508.938-5.248,1.454-1.036.338-2.122.477-3.163.793a14.9,14.9,0,0,1-4.1,1.18,2.693,2.693,0,0,1-1.6-.235,1.74,1.74,0,0,1-.737-.977c-.094-.234-.182-.47-.265-.707a.442.442,0,0,0,.027-.162c1.372-.368,3-1.105,2.76-2-.281-.219-.7-.111-1.04-.071a10.1,10.1,0,0,0-2.251.493l-.033-.1c-.135-.4-.269-.792-.4-1.19q-.1-.315-.184-.632c1.038-.206,2.374-.463,2.816-1.416.272-.738-.953-.33-1.344-.256-.594.159-1.187.325-1.789.446q-.083-.342-.161-.686l-.005-.023c-.1-.442-.194-.9-.288-1.37.416-.1.832-.208,1.247-.312a1.861,1.861,0,0,0,1.554-1.135c.072-.214.09-.542-.209-.568a11.983,11.983,0,0,0-2.706.459l-.183.059c-.13-.649-.271-1.295-.411-1.941.225-.041.392-.076.465-.092a5.4,5.4,0,0,0,1.361-.49,1.06,1.06,0,0,0,.768-.657c.038-.113.061-.362-.129-.352-.257.02-.5-.091-.754-.086a13.966,13.966,0,0,0-2.012.28c-.111-.507-.225-1.012-.349-1.517q-.087-.356-.18-.71c.234-.084.468-.167.7-.241.524-.126,1.168-.259,1.348-.846.218-.762-.854-.143-1.19-.094-.371.087-.75.143-1.128.2-.215-.776-.442-1.549-.674-2.32l.466-.147c.646-.286,1.529-.387,1.774-1.159.094-.2.029-.524-.249-.458-.794.115-1.612.221-2.408.4-.194-.631-.388-1.262-.569-1.9.226-.081.452-.16.679-.235.684-.281,1.634-.359,1.9-1.165.223-.7-.481-.373-.854-.331-.629.141-1.27.207-1.908.3l-.208.036c-.1-.374-.195-.749-.281-1.127h0c0-.01-.005-.02-.007-.031-.021-.1-.05-.23-.077-.36s-.053-.256-.079-.385c1-.315,2.04-.771,2.287-1.623.184-.927-1.782-.158-2.232-.085q-.2.057-.4.126-.064-.27-.133-.538c-.118-.456-.243-.91-.37-1.364.856-.225,1.872-.42,2.177-1.363.114-.268.052-.672-.322-.593a11.537,11.537,0,0,0-1.182.257c-.355.09-.714.175-1.071.267-.2-.719-.4-1.437-.617-2.153l0-.015c.629-.2,1.407-.149,1.837-.7.159-.212.356-.521.224-.788-.228-.275-1.042.226-1.373.271q-.489.135-.982.243c-.134-.452-.261-.905-.365-1.363-.043-.207-.081-.413-.111-.621s-.049-.417-.061-.627c0-.085,0-.17,0-.255,0-.053.009-.1.018-.157a1.02,1.02,0,0,1,.024-.1,1.265,1.265,0,0,1,.069-.154,1.6,1.6,0,0,1,.209-.264,2.127,2.127,0,0,1,.4-.3,2.7,2.7,0,0,1,.739-.25c.25-.044.5-.069.755-.1s.519-.066.778-.1c.4-.048.8-.088,1.2-.146.424-.062.847-.127,1.267-.21.825-.163,1.648-.351,2.461-.567s1.615-.468,2.413-.733c.4-.133.794-.273,1.193-.406.418-.139.84-.265,1.265-.381.409-.112.82-.212,1.234-.307l.593-.135c.2-.044.4-.084.589-.145.411-.131.813-.286,1.228-.408.385-.112.777-.2,1.171-.272.355-.064.706-.133,1.055-.222s.683-.185,1.018-.295c.177-.057.353-.117.524-.189s.349-.155.526-.229a8.735,8.735,0,0,1,1.047-.344c.327-.091.655-.182.984-.268a5.938,5.938,0,0,1,.723,1.637l0,.014c.025.082.048.165.071.247,0,.016.009.031.013.046.059.212.115.426.172.637",
    transform: "translate(-114.004 -9.046)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M256.731,41.836a10.987,10.987,0,0,1,.592,2.861.827.827,0,0,1-.2.35,5.076,5.076,0,0,1-.859.741,8,8,0,0,1-2.232.79c-.385.059-.769.131-1.147.223a7.76,7.76,0,0,0-1.9.258l-.03.01a12.51,12.51,0,0,0-.237-1.7,13.608,13.608,0,0,0,1.28-.488,4.5,4.5,0,0,0,1.831-1.03c.833-.77.483-1.693.271-2.644-.475-1.8-.557-3.916-1.879-5.341a1.553,1.553,0,0,0-.672-.18q.073-.053.144-.111a1.547,1.547,0,0,0,.273-.263,1.569,1.569,0,0,0,.143-.225.6.6,0,0,0,.085-.3,1.147,1.147,0,0,0-.034-.252,4.71,4.71,0,0,0-.177-.482,6.064,6.064,0,0,1-.3-.946c-.086-.4-.145-.8-.221-1.195s-.159-.786-.269-1.171a8.192,8.192,0,0,0-.472-1.236c-.081-.174-.168-.345-.255-.515-.1-.2-.205-.4-.326-.6a2.1,2.1,0,0,0-.4-.489,1.227,1.227,0,0,0-.7-.315c-.035,0-.07,0-.1,0l.168-.1c.111-.068.222-.139.329-.213a2.075,2.075,0,0,0,.277-.215,1,1,0,0,0,.355-.6,1.448,1.448,0,0,0-.036-.47,4.373,4.373,0,0,0-.155-.544c-.073-.192-.152-.381-.217-.576-.059-.175-.111-.354-.156-.533-.1-.376-.185-.755-.254-1.136-.043-.236-.092-.469-.146-.7a6.239,6.239,0,0,0-.17-.632c-.071-.207-.15-.411-.23-.614a6.378,6.378,0,0,0-.262-.6,2.527,2.527,0,0,0-.376-.549,3.538,3.538,0,0,0-.445-.406,2.077,2.077,0,0,0-.563-.348c-.043-.015-.086-.028-.129-.039a1.123,1.123,0,0,0,.383-.356.41.41,0,0,0,.033-.322c-.01-.044-.02-.088-.029-.132-.025-.118-.041-.238-.069-.356-.039-.163-.083-.326-.134-.486-.064-.2-.151-.4-.214-.6a6.422,6.422,0,0,1-.262-1.247c-.011-.11-.021-.264-.05-.415-.026-.131-.054-.262-.082-.392-.062-.281-.118-.563-.156-.848a8.133,8.133,0,0,0-.264-1.545,2.872,2.872,0,0,0-.672-1.2,1.888,1.888,0,0,0-1.217-.5,5.806,5.806,0,0,0-1.277.093,5.141,5.141,0,0,0-.6.136c-.049.015-.1.03-.149.048q-.206-.654-.443-1.3c-.035-.079-.071-.178-.11-.287.294-.072.589-.137.886-.194a11.189,11.189,0,0,0,1.211-.284c.193-.06.384-.124.58-.174s.406-.091.611-.129c.155-.028.332-.062.51-.086s.353-.035.529-.049a5.516,5.516,0,0,1,.95-.006,1.654,1.654,0,0,1,.29.068c.026.012.052.024.077.037s.052.036.077.055l.046.044q.043.05.085.1c.029.042.057.084.085.127.047.079.092.16.134.241.091.189.177.381.257.575.113.293.22.588.316.887l.044.143c.185.607.333,1.223.473,1.84q.078.353.15.707c.171.843.327,1.688.506,2.53.184.864.407,1.719.639,2.572.227.835.47,1.665.715,2.494s.5,1.672.756,2.506c.015.049.042.138.07.226l.075.241.058.186c.024.078.051.162.077.246l0,.011.016.052.061.194q.048.155.1.31c.007.026.015.052.025.077s.017.055.026.083l0,.011.014.043c.094.3.2.627.3.952l.077.246.052.166a.035.035,0,0,0,0,0l.007.024c.24.783.477,1.567.7,2.354.217.759.424,1.521.643,2.279.246.856.5,1.711.724,2.572s.43,1.7.636,2.554c.2.834.421,1.663.62,2.5q.049.207.1.413a1,1,0,0,0,.081.374c.007.02.013.04.02.06.127.554.252,1.109.383,1.663a.657.657,0,0,0,.131.264.235.235,0,0,0,.17.1h.01",
    transform: "translate(-174.535 -6.273)",
    fill: "#1b3c6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M246.729,19.538a3.7,3.7,0,0,1,.191.609c.044.195.091.39.13.586.072.37.116.744.156,1.119.021.211.039.423.062.634a3.488,3.488,0,0,0,.083.517c.049.181.112.358.166.538s.1.365.145.549c.041.164.082.328.119.493s.068.358.111.537a6.586,6.586,0,0,1,.145.715.912.912,0,0,1-.01.21l-.007.024c-.015.026-.031.05-.047.075s-.022.027-.034.04l-.047.042-.077.053c-.025.015-.051.03-.077.044-.071.035-.143.068-.216.1-.169.066-.341.122-.513.178a5.926,5.926,0,0,0-.638.149c-.141.043-.278.088-.414.143-.567-2.677-1.038-5.428-1.829-8.072.059-.011.118-.024.177-.038.172-.039.343-.082.515-.122.09-.019.179-.036.269-.05s.167-.021.25-.027l.147,0c.059,0,.118.01.177.017s.091.017.136.028l.1.036a2.3,2.3,0,0,1,.264.15,2.029,2.029,0,0,1,.269.248,2.474,2.474,0,0,1,.3.483",
    transform: "translate(-176.342 -13.418)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M262.57,81c.062.2.112.412.165.618a10.869,10.869,0,0,1,.189,1.182c.057.41.125.819.208,1.225a9.9,9.9,0,0,0,.249,1.031,4.306,4.306,0,0,1,.21.755,1.527,1.527,0,0,1,.007.182c0,.053,0,.1,0,.156,0,.006,0,.011-.006.017l-.005.009-.017.02c-.03.028-.062.055-.094.081-.075.056-.152.11-.23.162l-.059.034-.022.005c-.037.009-.074.018-.111.029a3.829,3.829,0,0,0-.457.165c-.155.067-.3.147-.46.211-.085.034-.169.068-.251.107a1.089,1.089,0,0,0-.219.136c-.067.014-.133.029-.2.046-.428-1.716-.878-3.428-1.349-5.124q-.353-1.3-.728-2.591c.063-.013.125-.028.187-.043.4-.087.8-.152,1.2-.211.146-.02.293-.037.44-.048h.069l.036.007c.024.008.048.016.072.025s.071.039.106.061a2.032,2.032,0,0,1,.3.276,3.8,3.8,0,0,1,.555.892,5.873,5.873,0,0,1,.219.585",
    transform: "translate(-187.366 -57.175)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M269.966,108.927a4.332,4.332,0,0,1,1,2.315c.243.967.292,1.968.5,2.942a3.769,3.769,0,0,1,.091,1.69,3.679,3.679,0,0,1-2.352,1.193c-.266-1.23-.578-2.415-.617-2.737-.366-1.679-.757-3.366-1.171-5.05a4.389,4.389,0,0,1,.441-.114,6.694,6.694,0,0,1,2.1-.238",
    transform: "translate(-193.169 -78.66)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M254.8,52.608c.114.365.206.733.29,1.1a9.31,9.31,0,0,1,.171.97c.015.161.028.322.058.48.024.129.053.258.081.387.038.177.088.352.115.531a.432.432,0,0,1,0,.05c-.007.029-.015.056-.024.084l0,.006q-.042.055-.089.1l-.028.024-.036.025c-.064.038-.128.073-.194.107s-.137.066-.208.1c-.216.082-.436.158-.653.238-.175.063-.346.134-.518.2l-.088.035c-.093.037-.187.072-.28.108l-.118.043c-.737-2.543-1.495-5.081-2.121-7.653l-.025-.115c.067-.009.132-.021.192-.031.152-.027.3-.06.454-.094.233-.053.461-.121.693-.177.109-.023.22-.044.331-.061l.109-.012h.012l.066.015c.05.015.1.032.149.051a2.058,2.058,0,0,1,.207.114,2.2,2.2,0,0,1,.274.25,3.616,3.616,0,0,1,.5.817,4.906,4.906,0,0,1,.189.509c.06.194.106.39.156.587.1.4.221.805.345,1.2",
    transform: "translate(-181.395 -35.441)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M206.09,70.777c-.107-4.385-2.284-9.394-7.509-7.367-1.192.546-2.78,1.244-3.484,2.391a6.09,6.09,0,0,0-.562,2.092,7.89,7.89,0,0,0,.819,4.066c1.074,2.269,2.382,4.737,4.577,6.091a5.062,5.062,0,0,0,2.178,1.023,2.642,2.642,0,0,0,1.849-.457,4.87,4.87,0,0,0,1.662-2.452,15.083,15.083,0,0,0,.47-5.388m1.176-3.323a17.294,17.294,0,0,1,.8,4.943,10.647,10.647,0,0,1-2.121,6.546,10.4,10.4,0,0,1-1.57,1.463c-.144.047-.288.092-.435.132a5.061,5.061,0,0,1-1.131.157c-.171-.021-.342-.043-.512-.056-.473-.053-.943-.132-1.415-.184a3.4,3.4,0,0,0-1.261-.006l-.135-.042c-.2-.071-.425-.159-.651-.259-.2-.089-.4-.194-.6-.3l-.005,0-.011-.006c-.26-.147-.527-.3-.783-.467s-.515-.348-.765-.533c-.126-.1-.256-.191-.377-.3s-.256-.226-.382-.342c-.14-.137-.309-.306-.476-.477-.14-.142-.269-.293-.4-.444-.2-.252-.395-.511-.582-.775-.123-.182-.249-.364-.364-.552s-.229-.378-.342-.568c-.235-.422-.451-.853-.658-1.29-.138-.309-.273-.619-.392-.936l-.009-.025-.013-.036-.016-.044-.006-.016-.006-.016c-.014-.039-.03-.081-.044-.122l-.019-.051,0,0-.008-.021c-.107-.316-.21-.636-.3-.96-.1-.383-.182-.769-.257-1.159-.029-.172-.053-.343-.075-.517s-.028-.339-.027-.508v0c0-.007,0-.013,0-.02,0-.06,0-.123,0-.188V69.41c.015-.273.037-.543.071-.814.024-.162.044-.328.08-.488s.079-.334.124-.5c.1-.322.207-.641.332-.954s.264-.595.411-.885c.217-.4.451-.8.706-1.178.127-.191.274-.37.416-.551s.28-.352.426-.523l.13-.147c.211-.223.453-.453.707-.674.116-.1.233-.2.357-.291s.248-.173.376-.254a11.319,11.319,0,0,1,1.736-.85c.3-.119.611-.227.924-.321s.61-.174.918-.248c.1-.024.242-.055.38-.084a.141.141,0,0,0,.075-.039c.518-.036,1.038-.058,1.554-.1a7.249,7.249,0,0,1,1.5.254,5.7,5.7,0,0,1,2.5,2.607,17.267,17.267,0,0,1,1.615,4.082",
    transform: "translate(-138.631 -43.709)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M199,37.408c.521-.112,2.225-.62,2.322.181.169.922.485,1.811.673,2.731a57.072,57.072,0,0,0-6.051,1.276c-1.823.5-3.8.852-5.353,1.982-.25-.052-.5.119-.737.142-.106-.269-.088-.572-.167-.85a5.673,5.673,0,0,1-.322-1.787A58.925,58.925,0,0,1,199,37.408",
    transform: "translate(-136.774 -26.832)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M212.138,74.3a8.774,8.774,0,0,1,1.241,3.241,19.008,19.008,0,0,1,.25,2.666,9.4,9.4,0,0,1-.8,4.965,3.735,3.735,0,0,1-1.855,1.98,4.769,4.769,0,0,1-2.882-.786c-2.267-1.367-3.587-3.849-4.545-6.237a5.244,5.244,0,0,1,.205-4.821c1.427-1.981,4.081-2.591,6.4-2.24a2.531,2.531,0,0,1,1.991,1.231",
    transform: "translate(-146.678 -52.711)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M190.682,43.382c-.366-.035-.522-.413-.652-.706a1.69,1.69,0,0,1,.447-2.007c1.816-1.615,6.476-3.039,8.916-3.474.416-.08.831-.169,1.246-.251a.551.551,0,0,1,.528.859c-.126.218-.508.248-.693.292-1.378.316-2.742.695-4.094,1.108a14.8,14.8,0,0,0-4.29,1.909,1.459,1.459,0,0,0-.849,1.642.545.545,0,0,1-.558.629",
    transform: "translate(-137.147 -26.679)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M198.009,78.748a.285.285,0,0,1-.1-.13,10.237,10.237,0,0,1-2.457-3.285,15.433,15.433,0,0,1-1.626-7.438,7.123,7.123,0,0,1,2.772-4.733,12.235,12.235,0,0,1,3.726-2.208,6.277,6.277,0,0,1,3.078-.291,6.016,6.016,0,0,1,1.005.241c.286.046.584.227.509.561a.433.433,0,0,1-.511.328c-.248-.058-.5-.1-.749-.151a6.1,6.1,0,0,0-1.383-.186,6.343,6.343,0,0,0-2.515.589,7.948,7.948,0,0,0-4.662,4.215,8.324,8.324,0,0,0-.042,6.4A12.243,12.243,0,0,0,197,76.612a18.7,18.7,0,0,1,1.337,1.647.3.3,0,0,1-.331.489",
    transform: "translate(-139.979 -43.768)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M246.455,20.435c-.287-.131-.58-.251-.876-.358a.938.938,0,0,1-.411-.174.333.333,0,0,1,.238-.559,2.443,2.443,0,0,1,1.363.426.369.369,0,0,1-.314.665",
    transform: "translate(-177.025 -13.966)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M254.344,51a3.428,3.428,0,0,0-1.167-.532.292.292,0,0,1-.333-.155.278.278,0,0,1,.154-.371,1.052,1.052,0,0,1,.955.054,5.642,5.642,0,0,1,.77.488.32.32,0,0,1-.379.516",
    transform: "translate(-182.621 -36.009)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M262.55,81.362c-.32-.248-.712-.383-1.042-.606-.214-.221.077-.485.317-.486a1.257,1.257,0,0,1,.875.319c.147.13.369.225.4.438a.353.353,0,0,1-.554.336",
    transform: "translate(-188.843 -57.98)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M256.057,50.611a1.169,1.169,0,0,1-.6-.417c-.22-.418.249-.594.584-.443a.759.759,0,0,1,.5.472.362.362,0,0,1-.487.388",
    transform: "translate(-184.486 -35.899)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M274.084,110.69c-.229-.161-.748-.482-.39-.77.321-.165.654.185.774.459a.257.257,0,0,1-.384.31",
    transform: "translate(-197.611 -79.369)",
    fill: "#ffb000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M212.452,116.61h0",
    transform: "translate(-153.462 -84.232)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M212.415,116.572l.007.007-.007-.007",
    transform: "translate(-153.435 -84.204)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M212.441,116.6h0",
    transform: "translate(-153.454 -84.225)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M167.881,58.045a.827.827,0,0,1-.481-1.468,1.187,1.187,0,0,1,1.015-.188.651.651,0,0,1,.217,1.06.768.768,0,0,1-.751.6",
    transform: "translate(-120.697 -40.696)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M163.875,46.951c-.821-.408-.45-1.808.513-1.56.809.016,1,1.364.115,1.433a.594.594,0,0,1-.628.127",
    transform: "translate(-118.046 -32.766)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M260.4,47.205a.853.853,0,0,1-.165-.346.332.332,0,0,1,.059-.507.325.325,0,0,1,.447.11c.81.293.237,1.277-.341.743",
    transform: "translate(-187.91 -33.448)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M268.936,76.559a.608.608,0,0,1-.4-1.056c-.118-.445.5-.577.538-.13a.607.607,0,0,1-.141,1.186",
    transform: "translate(-193.838 -54.244)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M193.644,169.49h0",
    transform: "translate(-139.874 -122.429)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M193.572,169.489h0",
    transform: "translate(-139.824 -122.428)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M286.375,87.15h0",
    transform: "translate(-206.859 -62.952)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M286.359,87.106l0,.008,0-.008",
    transform: "translate(-206.848 -62.92)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M297.479,134.559l0,.008a.044.044,0,0,1,0-.008",
    transform: "translate(-214.88 -97.197)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M265.019,14.908l.008.022-.008-.022",
    transform: "translate(-191.433 -10.769)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M264.995,14.842l0-.005.006.015,0-.01",
    transform: "translate(-191.414 -10.717)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M225.545,131.678a5.212,5.212,0,0,1-2.083.051,3.706,3.706,0,0,1-1.929-.555.485.485,0,0,1-.01-.632.933.933,0,0,1,.187-.15q.154.057.309.106c.227.072.455.139.681.211a2.666,2.666,0,0,0,1.415.19l.056-.014.093.011a.391.391,0,0,0,.143-.011.411.411,0,0,0,.2-.13c.119-.039.238-.079.359-.116a4.835,4.835,0,0,0,.7-.278,3.147,3.147,0,0,0,.657-.411c.119-.1.236-.21.349-.32a.848.848,0,0,1,.145,1.557,4.488,4.488,0,0,1-1.188.471l-.084.022",
    transform: "translate(-159.933 -93.635)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    transform: "translate(55.908 19.298)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M202.111,77.577c.042.218.08.436.12.655.167.418.335.836.511,1.251.085.189.171.377.254.568.079.174.162.347.234.524l.135.331c.041.1.08.2.112.3l.079.092q.43.5.847,1.016a.248.248,0,0,1,.029.269h0l0,0,0,0,.018.017.585.559a.077.077,0,0,1,.038.019l.632.588.03.029.028.024.108.1.448.372-.033-.027q.379.309.759.617l.2.164.114.062h0c.052.026.1.052.155.076a.469.469,0,0,1,.351.106l.017.015a.615.615,0,0,0-.128-.73q-.208-.193-.4-.4c-.929-1.254-2.144-2.247-2.967-3.6-.749-2.51-1.548-4.855.04-7.274a5.976,5.976,0,0,1,3.019-2.194,14.98,14.98,0,0,1,1.951.109,4.155,4.155,0,0,0,1.234.029.751.751,0,0,0,.228-.094l-.073-.059q-.243-.2-.49-.389c-.147-.116-.293-.234-.445-.343l-.551-.394-.173-.115a.563.563,0,0,1-.1.042.6.6,0,0,1-.372,0,2.7,2.7,0,0,1-.407-.176q-.123-.059-.245-.121c-.056-.028-.111-.057-.165-.088a9.688,9.688,0,0,0-1.234.052l-.383.146c-.075.033-.149.067-.222.1-.308.176-.6.369-.917.537-.184.1-.371.192-.558.285a.854.854,0,0,1-.091.1c-.139.128-.292.24-.439.36a3.906,3.906,0,0,1-.77.554,1.272,1.272,0,0,1-.214.079.88.88,0,0,1-.492,0c-.042.051-.084.1-.125.155a6.58,6.58,0,0,0-1.047,2.434.449.449,0,0,1,.271.339q.144,1.007.314,2.01c.052.308.116.615.174.922",
    transform: "translate(-201.352 -69.502)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(60.556 19.585)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M218.093,70.552l0,0,.027-.016-.031.018",
    transform: "translate(-218.093 -70.534)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(53.606 42.329)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M194.533,154.635a1.077,1.077,0,0,0,.151-2.044,1.1,1.1,0,0,0-1.573,1.286,1.154,1.154,0,0,0,1.422.758",
    transform: "translate(-193.062 -152.448)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(52.729 39.142)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M191.644,141.248c-1.188-1.036-2.49,1.083-1.219,1.824a1.11,1.11,0,0,0,1.219-1.824",
    transform: "translate(-189.903 -140.968)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(51.713 35.665)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M186.722,128.944a1.183,1.183,0,0,0,.74,2.125,1.315,1.315,0,0,0,.8-2.262.909.909,0,0,0-1.54.137",
    transform: "translate(-186.244 -128.447)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(51.049 32.452)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M184.085,118.555a1.012,1.012,0,1,0,1.23-1.553,1.012,1.012,0,0,0-1.23,1.553",
    transform: "translate(-183.852 -116.875)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(49.917 28.962)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M180.375,104.393a1.024,1.024,0,0,0,.148,1.92,1.128,1.128,0,0,0,1.344-.86,1.094,1.094,0,0,0-1.492-1.06",
    transform: "translate(-179.773 -104.305)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(49.062 25.771)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M177.969,93.016a.757.757,0,0,0-1.26.5.89.89,0,0,0,1.024,1c.746-.1,1.088-1.28.236-1.5",
    transform: "translate(-176.697 -92.815)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(48.257 22.109)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M174.091,81.514c.924,1.064,2.409-.5,1.4-1.418-.808-1.161-2.334.016-1.4,1.418",
    transform: "translate(-173.796 -79.624)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(47.216 18.623)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M171.88,67.662a.953.953,0,1,0-1.639.948c.527,1.1,2.107.006,1.639-.948",
    transform: "translate(-170.049 -67.072)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(45.074 11.887)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M163.266,45.218a1.207,1.207,0,0,0,.8-2.257,1.207,1.207,0,1,0-.8,2.257",
    transform: "translate(-162.334 -42.812)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(46.05 15.139)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M166.949,54.53c-1.334-.136-1.525,2.172-.183,2.28a1.144,1.144,0,0,0,.183-2.28",
    transform: "translate(-165.849 -54.524)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(70.635 5.264)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M260.346,53.963a1.844,1.844,0,0,0,.259-.049,1,1,0,0,0,.525-.323.734.734,0,0,0,.289,0c1.43-.229,2.141-1.673,2.375-2.971a10.365,10.365,0,0,0-.867-5.65c.263-.98-1.469-3.652-1.621-4.45-.579-1.693-.519-3.533-1.448-5.115a2.125,2.125,0,0,0-.341-.492.388.388,0,0,0,.125-.3,14.878,14.878,0,0,0-.24-1.926,20.888,20.888,0,0,0-1.508-5.318,4.741,4.741,0,0,0-1.078-1.7,1.766,1.766,0,0,1-.018-.252,14.672,14.672,0,0,0-.77-4.248,3.435,3.435,0,0,1-.183-.649,4.249,4.249,0,0,0-.534-1.218c-.191-.361-.752-.521-.9-.046a1.03,1.03,0,0,0,.141.647,7.471,7.471,0,0,0,.834,1.678c.18.889.311,1.788.536,2.667a6.991,6.991,0,0,1,.256,1.066,2.527,2.527,0,0,0-.011.452.524.524,0,0,0-.2.413,5.133,5.133,0,0,0,.329,1.191,26.492,26.492,0,0,1,1.946,5.106c.165.66.345,1.316.5,1.979a1.057,1.057,0,0,0-.161-.038.369.369,0,0,0-.4.5,4.324,4.324,0,0,0,.612,1.648c.194.582.375,1.169.574,1.75a11.544,11.544,0,0,1,.753,3.047c.1.51.062,1.467.579,1.7.556,1.844,1.1,3.693,1.588,5.556a2.912,2.912,0,0,1-1.5,3.557.7.7,0,0,0-.059.064,1.389,1.389,0,0,0-.7-.2,1.055,1.055,0,0,0-.71.312c.006.1.014.208.023.311.03.308.067.614.1.922.007.059.013.118.019.177a1.089,1.089,0,0,0,.879.2",
    transform: "translate(-254.391 -18.957)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(79.533 24.246)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M286.439,87.321a.12.12,0,0,0,0,.013l0-.007,0-.006",
    transform: "translate(-286.439 -87.321)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(53.195 1.443)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M219.871,32.733a54.674,54.674,0,0,1-1.707-5.6c-.458-1.92-.734-3.878-1.173-5.8a71.248,71.248,0,0,0-2.33-8.156c-.582-1.552-1.058-3.141-1.753-4.649-.468-.99-.776-2.063-1.324-3.012a.73.73,0,0,0-1.322.352.982.982,0,0,1,.192.007,1.035,1.035,0,0,1,.491.23,1.9,1.9,0,0,1,.365.388,3.2,3.2,0,0,1,.328.568c.121.256.218.526.319.791a.2.2,0,0,0,.008.022l0,0,.006.015,0,.006h0l.008.021c.075.194.145.388.215.582.083.229.153.462.226.7l-.005-.016q.1.324.189.652a.479.479,0,0,1,.247.174,1.087,1.087,0,0,1,.109.167c.031.063.057.127.083.193.041.1.078.208.115.313a3.16,3.16,0,0,1,.117.425c.059.284.114.567.165.852.049.268.09.536.126.805a2.983,2.983,0,0,1-.019.877.379.379,0,0,1-.123.216c.533,1.622.945,3.28,1.339,4.947a.631.631,0,0,1,.252.287,5.966,5.966,0,0,1,.232.666c.062.207.127.413.193.619.128.4.272.8.4,1.2q.181.574.346,1.154a12.279,12.279,0,0,0,.383,1.174c.093.218.19.434.273.655s.14.437.218.653.166.452.236.683.121.443.188.663c.08.251.161.5.232.755.064.231.127.461.2.688l-.031-.082.019.051,0,0,0,.009h0l.01.027.006.015,0,.011.011.029c0-.012-.009-.024-.013-.036l.051.138c.081.212.171.421.249.635s.127.418.182.629l.01.039,0,.007v0l.008.03,0,.014.022.084c.053.2.106.394.155.591a3.972,3.972,0,0,1,.084.72c0-.027,0-.053,0-.08l.008.133c0,.017,0,.035,0,.053v-.014c.006.083.012.165.018.249.012.123.023.245.035.368s.028.262.042.393c0,0,0-.01,0-.015.006.061.013.121.019.182V32.16c0,.019,0,.039.006.058v-.01c0,.012,0,.024,0,.035,0,.031.007.062.011.093.058.473.138.943.215,1.413.034.213.074.425.106.638l.063.419c.006.043.013.087.018.132.315,1.049.607,2.107.853,3.186q.032.143.064.286a1.075,1.075,0,0,1,.128.256c.047.119.09.238.13.359h.009a.278.278,0,0,1,.232.212c.006.019.011.038.015.058a.364.364,0,0,1,.135.265c.011.115.021.231.032.346.057.549.147,1.094.246,1.637.046.215.092.43.124.646.018.062.035.125.052.187a.476.476,0,0,1-.117.45.33.33,0,0,1-.2.134l-.009,0a.435.435,0,0,1-.1.015l.005.123a2.141,2.141,0,0,0-.141.184,4.469,4.469,0,0,1-1.107.811,25.781,25.781,0,0,1-3.9,1.3c-2.27.591-4.536,1.2-6.8,1.806-2.465.706-4.93,1.422-7.442,1.945-1.89.383-3.78.787-5.694,1.014a.521.521,0,0,1-.25.212,4.347,4.347,0,0,1-.516.168l-.121.031a8.829,8.829,0,0,1-.879.193,5.311,5.311,0,0,1-.745.054c-.213.008-.425.019-.638.012-.144,0-.288-.017-.432-.019h-.022c-.048,0-.095,0-.142-.005h.071l.073-.01a.6.6,0,0,1-.431-.083c-.015-.01-.03-.021-.044-.033a.927.927,0,0,0,.235,1.043c.756.708,2.1.648,3.075.594,1.146-.155,2.27-.441,3.4-.67a28.118,28.118,0,0,0,3.507-.986c2.555-.816,5.176-1.391,7.792-1.973,2.179-.469,4.4-1.045,6.579-1.585q.65-.165,1.3-.338c.712-.191,1.422-.391,2.128-.606a3.546,3.546,0,0,0,2.36-1.652,2.264,2.264,0,0,0,.335-.618c.547-.859.283-2.127.15-3.082a56.863,56.863,0,0,0-2.649-8.078",
    transform: "translate(-191.582 -5.197)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(82.44 36.138)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M296.912,130.2l0-.027c0-.005,0-.011,0-.016,0,.015,0,.029,0,.044",
    transform: "translate(-296.907 -130.152)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(79.538 24.258)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M286.458,87.371h0v0l0,0",
    transform: "translate(-286.456 -87.367)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(79.525 24.223)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M286.409,87.241l.008.022,0-.009,0-.013",
    transform: "translate(-286.409 -87.241)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(52.397 9.354)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M189,42.2a3.076,3.076,0,0,0,2.4.31c1.377-.265,2.526-1.133,3.867-1.52,1.371-.54,2.825-.791,4.218-1.257,1-.356,2.171-.371,3.049-1.012a2.383,2.383,0,0,0,.4-2.792c-.277-.711-.06-1.771-.822-2.192a.479.479,0,0,0-.673.413c.032.685.538,1.252.7,1.912.039.3.14,1.338-.162,1.466-1.309.406-2.612.835-3.957,1.11-2,.616-3.953,1.4-5.935,2.079a12.237,12.237,0,0,1-2.868.756A.38.38,0,1,0,189,42.2",
    transform: "translate(-188.706 -33.69)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(59.961 16.506)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M221.3,81.37c.091-.019.181-.04.271-.064a7.436,7.436,0,0,0,4.247-3.7,12.526,12.526,0,0,0,1.055-4.948,11.679,11.679,0,0,0-.079-2.776,10.138,10.138,0,0,0-.275-1.325A12.869,12.869,0,0,0,226,67.338c-.357-.829-.609-1.7-.892-2.552a6.725,6.725,0,0,0-.611-1.728,5.926,5.926,0,0,0-1.5-2.079,5.867,5.867,0,0,0-1.409-1.074c-.337-.173-.72-.227-1.051-.415a.408.408,0,0,0-.532.152.267.267,0,0,1,.138.066c.084.048.17.093.254.141a3.2,3.2,0,0,1,.573.456l.054.051c.1.077.19.158.284.238.209.178.407.373.605.562q.144.137.29.273c.048.045.1.089.143.136l.077.08a1.271,1.271,0,0,1,.15.2.613.613,0,0,1,.094.341c.023.031.045.061.067.093.12.169.233.339.343.514a7.563,7.563,0,0,1,.528.989,3.724,3.724,0,0,1,.26.747c.095.2.185.4.273.6a7.065,7.065,0,0,1,.26.715c.079.252.157.5.236.756s.167.534.238.8.118.572.164.86c0,.017.006.034.008.051.035.177.072.354.114.53s.094.379.127.571.041.386.057.579.029.4.038.594a7.033,7.033,0,0,1,.074.971c0,.026-.005.052-.01.078s-.005.057-.009.084c0,0,0-.007,0-.01l0,.024v-.011c0,.01,0,.02,0,.03h0v0c-.03.267-.068.532-.092.8,0,.029,0,.059,0,.088a.359.359,0,0,1-.08.307,17.476,17.476,0,0,1-.359,3.033,5.841,5.841,0,0,1-3.427,3.874,6.7,6.7,0,0,1-.842.227.411.411,0,0,1-.175.1.382.382,0,0,1-.142.011l-.093-.011-.056.014a1.907,1.907,0,0,1-.91-.04,15.3,15.3,0,0,1-2.178-.46,2.14,2.14,0,0,0-1-.063c-.259.107-.086.449.067.583A5.791,5.791,0,0,0,221.3,81.37",
    transform: "translate(-215.95 -59.446)",
    fill: "#011e41"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M250.129,103.8h0",
    transform: "translate(-180.677 -74.976)",
    fill: "#011e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M250.129,103.79v0",
    transform: "translate(-180.677 -74.971)",
    fill: "#011e41"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoninBookLightDesktop);
export default __webpack_public_path__ + "static/media/PhoninBook-Light-Desktop.06f7465ee7ffe2f4f6733acf89a7b4d6.svg";
export { ForwardRef as ReactComponent };